// CacheKey 958e3f452686053475ffb1ed6c4fd091
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-LHC": {
    models: {
      encounter: "enrollment",
      encounters: "enrollments",
      Encounter: "Enrollment",
      Encounters: "Enrollments",
      unit: "agency",
      units: "agencies",
      Unit: "Agency",
      Units: "Agencies"
    },
    exports: {
      defaults: {
        encounter: {
          id: "Enrollment ID",
          status: "Enrollment Status"
        },
        unit: {
          group: "Agency Group",
          name: "Agency Name",
          type: "Agency Type"
        }
      }
    },
    ribbon: {
      encounters: "Enrollments"
    }
  }
}

